var m = require('mithril');
var formGroup = require('../../components/formGroup');
var ToggleSwitch = require('../../components/toggleSwitch');

function controlId(model, key) {
  return model['@class'].toLowerCase() + '-' + key + '-input';
}

function helpText(text) {
  if (!text) return null;
  return m('small.db.moon-gray.mt1.lh-copy', text);
}

function text(model, key, label, help, options) {
  var opts = options || {};
  var id = controlId(model, key);
  return m(formGroup, [
    m('label', { for: id }, label),
    m('input.form-control', {
      id: id,
      autocomplete: 'off',
      spellcheck: false,
      autocorrect: 'off',
      type: opts.type || 'text',
      placeholder: opts.placeholder || '',
      oninput: function (ev) { model.form[key](ev.target.value); },
      value: model.form[key]()
    }),
    helpText(help)
  ]);
}

function textarea(model, key, label, help, options) {
  var opts = options || {};
  var id = controlId(model, key);
  return m(formGroup, [
    m('label', { for: id }, label),
    m('textarea.form-control', {
      id: id,
      class: opts.tall ? 'h5' : 'h4',
      placeholder: opts.placeholder || '',
      spellcheck: false,
      autocorrect: 'off',
      oninput: function (ev) { model.form[key](ev.target.value); },
      value: model.form[key]()
    }),
    helpText(help)
  ]);
}

function select(model, key, label, options, help, config) {
  var cfg = config || {};
  var id = controlId(model, key);
  var attrs = {
    id: id,
    value: cfg.value ? cfg.value() : model.form[key](),
    disabled: typeof cfg.disabled === 'function' ? cfg.disabled() : Boolean(cfg.disabled)
  };
  if (cfg.oninput) {
    attrs.oninput = cfg.oninput;
  } else {
    attrs.onchange = cfg.onchange || function (ev) { model.form[key](ev.target.value); };
  }
  return m(formGroup, [
    m('label', { for: id }, label),
    m('select', attrs, options.map(function (option) {
      return m('option', { value: option.value }, option.name);
    })),
    helpText(help)
  ]);
}

function normalizeBoolean(value) {
  if (value === true || value === 1) return true;
  if (typeof value === 'string') {
    var normalized = value.trim().toLowerCase();
    return normalized === '1' || normalized === 'true' || normalized === 'yes' || normalized === 'on';
  }
  return false;
}

function switchField(label, help, checked, onchange) {
  var isChecked = normalizeBoolean(checked());
  return m(formGroup, [
    m('div.flex.items-center.justify-between', [
      m('label', label),
      m(ToggleSwitch, {
        size: 'modal',
        checked: isChecked,
        ariaLabel: label,
        onchange: function (ev) { onchange(Boolean(ev.target.checked)); }
      })
    ]),
    helpText(help)
  ]);
}

function modelSwitch(model, key, label, help, onValue, offValue) {
  var id = controlId(model, key);
  var value = model.form[key]();
  var checked = normalizeBoolean(value);
  return m(formGroup, [
    m('div.flex.items-center.justify-between', [
      m('label', { for: id }, label),
      m(ToggleSwitch, {
        id: id,
        size: 'modal',
        checked: checked,
        ariaLabel: label,
        onchange: function () {
          model.form[key](checked ? offValue : onValue);
        }
      })
    ]),
    helpText(help)
  ]);
}

function section(title, children) {
  return m('fieldset.bn.pa0.ma0.mb3', [
    m('legend.f4.fw6.near-white.mb2', title),
    children
  ]);
}

function details(title, children, open) {
  return m('details.mb3', { open: open }, [
    m('summary.f4.fw6.near-white.pointer.mb2', title),
    children
  ]);
}

function collapsibleSection(options) {
  var index = options.index || 0;
  var isOpen = options.isOpen;
  return m('div.w-100.bw1.bb.pv2' + (index === 0 ? '.bt' : ''), [
    m('button.w-100.bn.bg-transparent.pa0.pointer.flex.justify-between.items-center', {
      type: 'button',
      onclick: options.toggle
    }, [
      m('p.f3.ma0.near-white', options.title),
      m('i.f1.blue.ion-ios-arrow-' + (isOpen() ? 'up' : 'down'))
    ]),
    m('div.w-100.pt2.pb3', {
      style: {
        display: isOpen() ? 'block' : 'none'
      }
    }, options.content)
  ]);
}

function columns(children) {
  return m('div.cf', children.map(function (child, index) {
    return m('div.fl.w-100.w-50-ns', { class: index % 2 === 0 ? 'pr2-ns' : 'pl2-ns' }, child);
  }));
}

function responseFormatValue(form) {
  if (form.responseFormat && form.responseFormat()) return form.responseFormat();
  if (form.html && Number(form.html())) return 'html';
  if (form.xml && Number(form.xml())) return 'xml';
  return 'json';
}

function setResponseFormat(form, value) {
  if (form.responseFormat) form.responseFormat(value === 'json' ? '' : value);
  if (form.html) form.html(value === 'html' ? 1 : 0);
  if (form.xml) form.xml(value === 'xml' ? 1 : 0);
}

module.exports = {
  collapsibleSection: collapsibleSection,
  columns: columns,
  details: details,
  responseFormatValue: responseFormatValue,
  section: section,
  select: select,
  setResponseFormat: setResponseFormat,
  modelSwitch: modelSwitch,
  switchField: switchField,
  text: text,
  textarea: textarea
};
